export const MAX_NAME_LENGTH = 255;

export const FOLDER_ACTIONS = {
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const TEMPLATE_FOLDER_TYPES = {
  EMAIL: "email_template",
  SMS: "sms_template",
};

export const TEMPLATE_VIEW_MODES = {
  LIST: "list",
  FOLDER: "folder",
};

// Large enough to fetch every template of a given type in one request for folder-view grouping.
export const FOLDER_VIEW_PAGE_SIZE = 1000;

export const SMS_TEMPLATE_VIEW_MODE_KEY = "sms_template_view_mode";
export const EMAIL_TEMPLATE_VIEW_MODE_KEY = "email_template_view_mode";
